import { render, staticRenderFns } from "./MerchantSingleForm.vue?vue&type=template&id=81de5d96&scoped=true"
import script from "./MerchantSingleForm.vue?vue&type=script&lang=js"
export * from "./MerchantSingleForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantSingleForm.vue?vue&type=style&index=0&id=81de5d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81de5d96",
  null
  
)

export default component.exports